
import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;
const gateApiUrl = process.env.REACT_APP_GATE_API_URL;

const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*", // Required for CORS support to work
    Authorization: getCookie("mawalog"),
};

 export const getDeviceListApi = async (params) => { 
  try {
    const response = await axios.get(
      apiUrl+`device?`+params,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getDeviceApi = async (id) => {
    try {
        const response = await axios.get(`${apiUrl}device/` + id, {
            headers: header,
        });
        return response; // ✅ make sure this line exists
    } catch (err) {
        console.error("Error saving device:", err.response?.data || err.message);
        return err.response; // ✅ rethrow the error so the caller knows
    }
};

export const getUserApi = async (term) => {
  try {
    const response = await axios.get(
      apiAdminUrl + `employee/autocomplete?term=` + term,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const saveDeviceApi = async (body) => {
    try {
        const response = await axios.post(`${apiUrl}device`, body, {
            headers: header,
        });
        return response; // ✅ make sure this line exists
    } catch (err) {
        console.error("Error saving customer:", err.response?.data || err.message);
        return err.response; // ✅ rethrow the error so the caller knows
    }
};
export const updateDeviceApi = async (body, id) => {
    try {
        const response = await axios.put(`${apiUrl}device/` + id, body, {
            headers: header,
        });
        return response; // ✅ make sure this line exists
    } catch (err) {
        console.error("Error saving customer:", err.response?.data || err.message);
        return err.response; // ✅ rethrow the error so the caller knows
    }
};
export const getDeptApi = async (term) => {
    try {
        const response = await axios.get(apiAdminUrl + `get_department?term=` + term, {
            headers: header,
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};

export const getLocationApi = async (term) => {
    try {
        const response = await axios.get(apiAdminUrl + `get_location?term=` + term, {
            headers: header,
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
